import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineWhatsApp,
  AiOutlineTwitter,
  AiFillInstagram,
  AiFillMail
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              NOS <span className="purple"> PRESENTAMOS </span>
            </h1>
            <p className="home-about-body">
              Somos <strong className="main-name">DATA</strong>MINDER, un equipo conformado
              en la carrera de Analista de Sistemas de la institución Cervantes.
              <br />
              <br />
              Creado por un grupo de 4 integrantes: <b className="purple"> Martín</b>, <b className="purple">Lucas</b>, <b className="purple">Franco</b> e <b className="purple">Iván</b>.
             
              Cada miembro aporta habilidades y experiencia en diversas áreas
              como{" "}
              <b className="purple">desarrollo, diseño, IT y administración</b>,
              generando una sinergia extraordinaria.
              <br />
              <br />
              Gracias a esto, hemos logrado destacar en el cursado con una tesis
              y proyectos notables, como un{" "}
              <b className="purple">sistema de gestión para Crystal Joyas</b> y
              una <b className="purple">plataforma de diseño web autogestionable</b>{" "}
              con inventario incluido.
              <br />
              <br />
              En <strong className="main-name">DATA</strong>MINDER, la innovación y agilidad
              son nuestra esencia. Nos enfrentamos a cada desafío priorizando
              <i>
                <b className="purple">
                {" "}seguridad, disponibilidad, confidencialidad
                </b>
              </i>
              , y creando diseños modernos, fluidos y adaptables a diferentes
              dispositivos, siempre pensando en la aceptabilidad del usuario.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>CONTACTO</h1>
            <p>
              Conéctate con <span className="purple">NOSOTROS</span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="mailto:ivan@dataminder.com.ar"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillMail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://wa.me/543513099723"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineWhatsApp />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/soumyajit4419/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/soumyajit4419"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li> */}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
